// Muss bei jedem Deploy zusammen mit APP_VERSION im Backend hochgezählt werden.
export const APP_VERSION = "2026.09.01-36";
